<template>
  <Layout>
    <section class="csms-ocpp">

      <PageHeader :title="title" />

      <div class="row viewport-height-fix">

        <!-- Left Area -->
        <div class="col-xl-6 mb-3 mb-xl-0">
          <div class="card flex-fill-card">
            <div class="card-body">
              <div class="section-title">Operations Management</div>

              <div class="form-area">

                <!-- // Operations -->
                <div class="form-row">
                  <label class="form-label col-4" for="selectOperations">
                    Operations <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectOperations"
                                   class="form-select"
                                   v-model="operations"
                                   :options="operationsOptions"
                                   @change="onChangeOperations" />
                  </div>
                </div>

                <!-- // Charge Point -->
                <div v-if="chargePoint.show" class="form-row">
                  <label class="form-label col-4">
                    Charge Point <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <div class="charge-point-box">
                      <!-- MULTI -->
                      <div v-if="chargePoint.type === 'MULTI'" class="cp-grid">
                        <label v-for="opt in chargePoint.options"
                               :key="opt.value"
                               class="cp-item"
                               :class="{ active: form.chargePoint.includes(opt.value) }" >
                          <input type="checkbox"
                                 :value="opt.value"
                                 v-model="form.chargePoint"
                                 @change="onDataChange('chargePoint')" />
                          <span>{{ opt.text }}</span>
                        </label>
                      </div>

                      <!-- SINGLE -->
                      <div v-else class="cp-grid">
                        <label v-for="opt in chargePoint.options"
                               :key="opt.value"
                               class="cp-item"
                               :class="{ active: form.chargePoint === opt.value }">
                          <input type="radio"
                                 :value="opt.value"
                                 v-model="form.chargePoint"
                                 @change="onDataChange('chargePoint')" />
                          <span>{{ opt.text }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- // Reservation ID -->
                <div v-if="reservation.show" class="form-row">
                  <label class="form-label col-4" for="selectReservationId">
                    Reservation ID <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectReservationId"
                                   class="form-select"
                                   v-model="form.reservationId"
                                   :options="reservation.options"
                                   @change="onDataChange('reservationId')" />
                  </div>
                </div>

                <!-- // Certificate Chain -->
                <div v-if="certificateChain.show" class="form-row">
                  <label class="form-label col-4" for="inputCertificateChain">
                    Certificate Chain
                    <span v-if="certificateChain.required" class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-textarea id="inputCertificateChain"
                                     v-model="form.certificateChain"
                                     rows="24"
                                     max-rows="24"
                                     @input="onDataChange('certificateChain')" />
                  </div>
                </div>

                <!-- // Connector ID -->
                <div v-if="connectorId.show" class="form-row">
                  <label class="form-label col-4" for="selectConnectorId">
                    Connector ID
                    <span v-if="connectorId.required" class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectConnectorId"
                                   class="form-select"
                                   v-model="form.connectorId"
                                   :options="connectorId.options"
                                   @change="onDataChange('connectorId')" />
                  </div>
                </div>

                <!-- // Avail Type -->
                <div v-if="availType.show" class="form-row">
                  <label class="form-label col-4" for="selectAvailType">
                    Avail Type <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectAvailType"
                                   class="form-select"
                                   v-model="form.availType"
                                   :options="availType.options"
                                   @change="onDataChange('availType')" />
                  </div>
                </div>

                <!-- // Configuration Key -->
                <div v-if="confKey.show" class="form-row">
                  <label class="form-label col-4">
                    Configure Key
                    <span v-if="confKey.required" class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <div class="charge-point-box">
                      <!-- MULTI -->
                      <div v-if="confKey.type === 'MULTI'" class="confkey-grid">
                        <label v-for="opt in confKey.options"
                               :key="opt.value"
                               class="cp-item"
                               :class="{ active: form.confKeyList.includes(opt.value) }" >
                          <input type="checkbox"
                                 :value="opt.value"
                                 v-model="form.confKeyList"
                                 @change="onDataChange('confKey')" />
                          <span>{{ opt.text }}</span>
                        </label>
                      </div>

                      <!-- SINGLE -->
                      <div v-else class="confkey-grid">
                        <label v-for="opt in confKey.options"
                               :key="opt.value"
                               class="cp-item"
                               :class="{ active: form.confKeyList === opt.value }">
                          <input type="radio"
                                 :value="opt.value"
                                 v-model="form.confKeyList"
                                 @change="onDataChange('confKey')" />
                          <span>{{ opt.text }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- // Value -->
                <div v-if="val.show" class="form-row">
                  <label class="form-label col-4" for="selectVal">
                    Value <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input type="text" v-model="form.value" @input="onDataChange('val')" />
                  </div>
                </div>

                <!-- // Profile -->
                <div v-if="profile.show" class="form-row">
                  <label class="form-label col-4" for="selectProfile">
                    Charging Profile
                    <span v-if="profile.required" class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectProfile"
                                   class="form-select"
                                   v-model="form.chargingProfilePk"
                                   :options="profile.options"
                                   @change="onDataChange('chargingProfilePk')" />
                  </div>
                </div>

                <!-- // Profile Purpose -->
                <div v-if="profilePurpose.show" class="form-row">
                  <label class="form-label col-4" for="selectProfilePurpose">
                    Profile Purpose
                    <span v-if="profilePurpose.required" class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectProfilePurpose"
                                   class="form-select"
                                   v-model="form.profilePurpose"
                                   :options="profilePurpose.options"
                                   @change="onDataChange('profilePurpose')" />
                  </div>
                </div>

                <!-- // Stack Level -->
                <div v-if="stackLevel.show" class="form-row">
                  <label class="form-label col-4" for="inputStackLevel">
                    Stack Level
                    <span v-if="stackLevel.required" class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input id="inputStackLevel"
                                  type="text"
                                  v-model="form.stackLevel"
                                  @input="onDataChange('stackLevel')" />
                  </div>
                </div>

                <!-- // Vendor ID -->
                <div v-if="vendorId.show" class="form-row">
                  <label class="form-label col-4" for="inputVendorId">
                    Vendor ID <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input id="inputVendorId"
                                  type="text"
                                  v-model="form.vendorId"
                                  @input="onDataChange('vendorId')" />
                  </div>
                </div>

                <!-- // Message ID -->
                <div v-if="messageId.show" class="form-row">
                  <label class="form-label col-4" for="inputMessageId">
                    Message ID
                    <span v-if="messageId.required" class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input id="inputMessageId"
                                  type="text"
                                  v-model="form.messageId"
                                  @input="onDataChange('messageId')" />
                  </div>
                </div>

                <!-- // Data -->
                <div v-if="data.show" class="form-row">
                  <label class="form-label col-4" for="inputData">
                    Data
                    <span v-if="data.required" class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input id="inputData"
                                  type="text"
                                  v-model="form.data"
                                  @input="onDataChange('data')" />
                  </div>
                </div>

                <!-- // Hash Algorithm -->
                <div v-if="hashAlgorithm.show" class="form-row">
                  <label class="form-label col-4" for="selectHashAlgorithm">
                    Hash Algorithm <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectHashAlgorithm"
                                   class="form-select"
                                   v-model="form.hashAlgorithm"
                                   :options="hashAlgorithm.options"
                                   @change="onDataChange('hashAlgorithm')" />
                  </div>
                </div>

                <!-- // Issuer Name Hash -->
                <div v-if="issuerNameHash.show" class="form-row">
                  <label class="form-label col-4" for="inputIssuerNameHash">
                    Issuer Name Hash <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input id="inputIssuerNameHash"
                                  type="text"
                                  v-model="form.issuerNameHash"
                                  @input="onDataChange('issuerNameHash')" />
                  </div>
                </div>

                <!-- // Issuer Key Hash -->
                <div v-if="issuerKeyHash.show" class="form-row">
                  <label class="form-label col-4" for="inputIssuerKeyHash">
                    Issuer Key Hash <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input id="inputIssuerKeyHash"
                                  type="text"
                                  v-model="form.issuerKeyHash"
                                  @input="onDataChange('issuerKeyHash')" />
                  </div>
                </div>

                <!-- // Serial Number -->
                <div v-if="serialNumber.show" class="form-row">
                  <label class="form-label col-4" for="inputSerialNumber">
                    Serial Number <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input id="inputSerialNumber"
                                  type="text"
                                  v-model="form.serialNumber"
                                  @input="onDataChange('serialNumber')" />
                  </div>
                </div>

                <!-- // Trigger Message -->
                <div v-if="messageTrigger.show" class="form-row">
                  <label class="form-label col-4" for="selectMessageTrigger">
                    Message Trigger <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectMessageTrigger"
                                   class="form-select"
                                   v-model="form.messageTrigger"
                                   :options="messageTrigger.options"
                                   @change="onDataChange('messageTrigger')" />
                  </div>
                </div>

                <!-- // Duration In Seconds -->
                <div v-if="durationInSeconds.show" class="form-row">
                  <label class="form-label col-4" for="inputDurationInSeconds">
                    Duration In Seconds <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input id="inputDurationInSeconds"
                                  type="number"
                                  v-model="form.durationInSeconds"
                                  @input="onDataChange('durationInSeconds')" />
                  </div>
                </div>

                <!-- // Charging Rate Unit -->
                <div v-if="chargingRateUnit.show" class="form-row">
                  <label class="form-label col-4" for="selectChargingRateUnit">
                    Charging Rate Unit <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectChargingRateUnit"
                                   class="form-select"
                                   v-model="form.chargingRateUnit"
                                   :options="chargingRateUnit.options"
                                   @change="onDataChange('chargingRateUnit')" />
                  </div>
                </div>

                <!-- // Comma Separated Custom Configuration Keys -->
                <div v-if="customConfKey.show" class="form-row">
                  <label class="form-label col-4" for="inputCustomConfKey">
                    Custom Conf Keys
                    <span v-if="customConfKey.required" class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input id="inputCustomConfKey"
                                  type="text"
                                  v-model="form.customConfKey"
                                  @input="onDataChange('customConfKey')" />
                  </div>
                </div>

                <!-- // Location -->
                <div v-if="location.show" class="form-row">
                  <label class="form-label col-4" for="inputLocation">
                    Location <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input id="inputLocation"
                                  type="text"
                                  v-model="form.location"
                                  @input="onDataChange('location')" />
                  </div>
                </div>

                <!-- // Retries -->
                <div v-if="retries.show" class="form-row">
                  <label class="form-label col-4" for="inputRetries">
                    Retries
                    <span v-if="retries.required" class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input id="inputRetries"
                                  type="number"
                                  v-model="form.retries"
                                  @input="onDataChange('retries')" />
                  </div>
                </div>

                <!-- // Retry Interval -->
                <div v-if="retryInterval.show" class="form-row">
                  <label class="form-label col-4" for="inputRetryInterval">
                    Retry Interval
                    <span v-if="retryInterval.required" class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input id="inputRetryInterval"
                                  type="number"
                                  v-model="form.retryInterval"
                                  @input="onDataChange('retryInterval')" />
                  </div>
                </div>

                <!-- // Start -->
                <div v-if="start.show" class="form-row">
                  <label class="form-label col-4" for="selectStart">
                    Start
                    <span v-if="start.required" class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <date-picker type="datetime" id="valid-to-date" lang="ko"
                                 v-model="form.start"
                                 :show-time-panel="showTimePanel" value-type="format"
                                 @close="handleOpenChange" @change="onDataChange('start')">
                      <template v-slot:footer>
                        <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                          {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                        </button>
                      </template>
                    </date-picker>
                  </div>
                </div>

                <!-- // Stop -->
                <div v-if="stop.show" class="form-row">
                  <label class="form-label col-4" for="selectStop">
                    Stop
                    <span v-if="stop.required" class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <date-picker type="datetime" id="valid-to-date" lang="ko"
                                 v-model="form.stop"
                                 :show-time-panel="showTimePanel" value-type="format"
                                 @close="handleOpenChange" @change="onDataChange('stop')">
                      <template v-slot:footer>
                        <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                          {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                        </button>
                      </template>
                    </date-picker>
                  </div>
                </div>

                <!-- // Certificate Type -->
                <div v-if="certificateType.show" class="form-row">
                  <label class="form-label col-4" for="selectCertificateType">
                    Certificate Type <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectCertificateType"
                                   class="form-select"
                                   v-model="form.certificateType"
                                   :options="certificateType.options"
                                   @change="onDataChange('certificateType')" />
                  </div>
                </div>

                <!-- // Remote Location -->
                <div v-if="remoteLocation.show" class="form-row">
                  <label class="form-label col-4" for="inputRemoteLocation">
                    Remote Location <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input id="inputRemoteLocation"
                                  type="text"
                                  v-model="form.remoteLocation"
                                  @input="onDataChange('remoteLocation')" />
                  </div>
                </div>

                <!-- // Oldest Timestamp -->
                <div v-if="oldestTimestamp.show" class="form-row">
                  <label class="form-label col-4" for="selectOldestTimestamp">
                    Oldest Timestamp
                  </label>
                  <div class="col-8">
                    <date-picker type="datetime" id="valid-to-date" lang="ko"
                                 v-model="form.oldestTimestamp"
                                 :show-time-panel="showTimePanel" value-type="format"
                                 @close="handleOpenChange" @change="onDataChange('oldestTimestamp')">
                      <template v-slot:footer>
                        <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                          {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                        </button>
                      </template>
                    </date-picker>
                  </div>
                </div>

                <!-- // Latest Timestamp -->
                <div v-if="latestTimestamp.show" class="form-row">
                  <label class="form-label col-4" for="selectLatestTimestamp">
                    Latest Timestamp
                  </label>
                  <div class="col-8">
                    <date-picker type="datetime" id="valid-to-date" lang="ko"
                                 v-model="form.latestTimestamp"
                                 :show-time-panel="showTimePanel" value-type="format"
                                 @close="handleOpenChange" @change="onDataChange('latestTimestamp')">
                      <template v-slot:footer>
                        <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                          {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                        </button>
                      </template>
                    </date-picker>
                  </div>
                </div>

                <!-- // Log Type -->
                <div v-if="logType.show" class="form-row">
                  <label class="form-label col-4" for="selectLogType">
                    Log Type <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectLogType"
                                   class="form-select"
                                   v-model="form.logType"
                                   :options="logType.options"
                                   @change="onDataChange('logType')" />
                  </div>
                </div>

                <!-- // Request Id -->
                <div v-if="requestId.show" class="form-row">
                  <label class="form-label col-4" for="inputRequestId">
                    Request ID <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-input id="inputRequestId"
                                  type="number"
                                  v-model="form.requestId"
                                  @input="onDataChange('requestId')" />
                  </div>
                </div>

                <!-- // Certificate -->
                <div v-if="certificate.show" class="form-row">
                  <label class="form-label col-4" for="inputCertificate">
                    Certificate <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-textarea id="inputCertificate"
                                     v-model="form.certificate"
                                     rows="24"
                                     max-rows="24"
                                     @input="onDataChange('certificate')" />
                  </div>
                </div>

                <!-- // ID Tag -->
                <div v-if="idTag.show" class="form-row">
                  <label class="form-label col-4" for="selectIdTag">
                    ID Tag <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
<!--                    <b-form-select id="selectIdTag"
                                   class="form-select"
                                   v-model="form.idTag"
                                   :options="idTag.options"
                                   @change="onDataChange('idTag')" />-->
                    <b-form-input id="selectIdTag"
                                  type="text"
                                  v-model="form.idTag"
                                  @input="onDataChange('idTag')" />
                  </div>
                </div>

                <!-- // Transaction ID -->
                <div v-if="transactionId.show" class="form-row">
                  <label class="form-label col-4" for="selectTransactionId">
                    Transaction ID <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectTransactionId"
                                   class="form-select"
                                   v-model="form.transactionId"
                                   :options="transactionId.options"
                                   @change="onDataChange('transactionId')" />
                  </div>
                </div>

                <!-- // Expiry -->
                <div v-if="expiry.show" class="form-row">
                  <label class="form-label col-4" for="selectExpiry">
                    Expiry <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <date-picker type="datetime" id="valid-to-date" lang="ko"
                                 v-model="form.expiry"
                                 :show-time-panel="showTimePanel" value-type="format"
                                 @close="handleOpenChange" @change="onDataChange('expiry')">
                      <template v-slot:footer>
                        <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                          {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                        </button>
                      </template>
                    </date-picker>
                  </div>
                </div>

                <!-- // Reset Type -->
                <div v-if="resetType.show" class="form-row">
                  <label class="form-label col-4" for="selectResetType">
                    Reset Type <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectResetType"
                                   class="form-select"
                                   v-model="form.resetType"
                                   :options="resetType.options"
                                   @change="onDataChange('resetType')" />
                  </div>
                </div>

                <!-- // Update Type -->
                <div v-if="updateType.show" class="form-row">
                  <label class="form-label col-4" for="selectUpdateType">
                    Update Type <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectUpdateType"
                                   class="form-select"
                                   v-model="form.updateType"
                                   :options="updateType.options"
                                   @change="onDataChange('updateType')" />
                  </div>
                </div>

                <!-- // Add Update List & Delete List -->
                <div class="row operation-drag mt-3" v-if="form.updateType === 'DIFFERENTIAL'">
                  <div class="col-4 text-center">
                    <div class="font-size-14 mb-3">ID Tag</div>
                    <draggable class="list-group" :list="idTag.options" group="updateType">
                      <div class="list-group-item" v-for="item in idTag.options" :key="item.value">
                        {{ item.text }}
                      </div>
                    </draggable>
                  </div>

                  <div class="col-4 text-center">
                    <div class="font-size-14 text-primary mb-3">Add Update List</div>
                    <draggable class="list-group" :list="form.addList" group="updateType" @change="onDataChange('addList')">
                      <div class="list-group-item" v-for="item in form.addList" :key="item.value">
                        {{ item.text }}
                      </div>
                    </draggable>
                  </div>

                  <div class="col-4 text-center">
                    <div class="font-size-14 text-primary mb-3">Delete List</div>
                    <draggable class="list-group" :list="form.delList" group="updateType" @change="onDataChange('delList')">
                      <div class="list-group-item" v-for="item in form.delList" :key="item.value">
                        {{ item.text }}
                      </div>
                    </draggable>
                  </div>
                </div>

                <!-- // Retrieve Date Time -->
                <div v-if="retrieveDateTime.show" class="form-row">
                  <label class="form-label col-4" for="selectRetrieveDateTime">
                    Retrieve Date Time <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <date-picker type="datetime" id="valid-to-date" lang="ko"
                                 v-model="form.retrieveDateTime"
                                 :show-time-panel="showTimePanel" value-type="format"
                                 @close="handleOpenChange" @change="onDataChange('retrieveDateTime')">
                      <template v-slot:footer>
                        <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                          {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                        </button>
                      </template>
                    </date-picker>
                  </div>
                </div>

                <!-- // Install Date Time -->
                <div v-if="installDateTime.show" class="form-row">
                  <label class="form-label col-4" for="selectInstallDateTime">
                    Install Date Time
                  </label>
                  <div class="col-8">
                    <date-picker type="datetime" id="valid-to-date" lang="ko"
                                 v-model="form.installDateTime"
                                 :show-time-panel="showTimePanel" value-type="format"
                                 @close="handleOpenChange" @change="onDataChange('installDateTime')">
                      <template v-slot:footer>
                        <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                          {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                        </button>
                      </template>
                    </date-picker>
                  </div>
                </div>

                <!-- // Signing Certificate -->
                <div v-if="signingCertificate.show" class="form-row">
                  <label class="form-label col-4" for="inputSigningCertificate">
                    Signing Certificate <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-textarea id="inputSigningCertificate"
                                     v-model="form.signingCertificate"
                                     rows="4"
                                     max-rows="4"
                                     @input="onDataChange('signingCertificate')" />
                  </div>
                </div>

                <!-- // Signature -->
                <div v-if="signature.show" class="form-row">
                  <label class="form-label col-4" for="inputSignature">
                    Signature <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-textarea id="inputSignature"
                                     v-model="form.signature"
                                     rows="4"
                                     max-rows="4"
                                     @input="onDataChange('signature')" />
                  </div>
                </div>

                <!-- // Trigger Message -->
                <div v-if="triggerMessage.show" class="form-row">
                  <label class="form-label col-4" for="selectTriggerMessage">
                    Trigger Message <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <b-form-select id="selectTriggerMessage"
                                   class="form-select"
                                   v-model="form.triggerMessage"
                                   :options="triggerMessage.options"
                                   @change="onDataChange('triggerMessage')" />
                  </div>
                </div>

                <!-- // Retrieve -->
                <div v-if="retrieve.show" class="form-row">
                  <label class="form-label col-4" for="selectRetrieve">
                    Retrieve <span class="text-danger">*</span>
                  </label>
                  <div class="col-8">
                    <date-picker type="datetime" id="valid-to-date" lang="ko"
                                 v-model="form.retrieve"
                                 :show-time-panel="showTimePanel" value-type="format"
                                 @close="handleOpenChange" @change="onDataChange('retrieve')">
                      <template v-slot:footer>
                        <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                          {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                        </button>
                      </template>
                    </date-picker>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Right Area -->
        <div class="col-xl-6">

          <!-- Request -->
          <div class="card flex-fill-card">
            <div class="card-body">
              <div class="section-title">Request</div>

              <div class="request-wrapper">
                <div class="request-data-table">
                  <pre>{{ requestText }}</pre>
                </div>

                <div class="mt-3 text-align-end">
                  <b-button size="sm" variant="outline-primary" @click="execute()">Execute</b-button>
                </div>
              </div>

            </div>
          </div>

          <!-- Response -->
          <div class="card flex-fill-card">
            <div class="card-body">
              <div class="section-title">Response</div>

              <div class="request-wrapper">
                <div class="request-data-table">
                  <pre>{{ response }}</pre>
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>
    </section>
  </Layout>
</template>

<script>
import { http } from '@/auth-api';
import { loadingMethods } from '@/state/helpers';
import i18n from '@/i18n';
import Layout from '@/views/layouts/Main.vue';
import PageHeader from '@/components/PageHeader.vue';
import draggable from 'vuedraggable';

export default {
  name: 'CsmsOcpp',
  components: { Layout, PageHeader, draggable },
  data() {
    return {
      title: 'operations',
      operations: null,
      operationsOptions: [],
      chargePoint: {
        show: false,
        type: 'MULTI',
        options: [],
      },
      reservation: {
        show: false,
        options: [],
      },
      certificateChain: {
        show: false,
        required: true
      },
      connectorId: {
        show: false,
        options: [],
        required: true,
      },
      availType: {
        show: false,
        options: [
          { value: 'INOPERATIVE', text: 'INOPERATIVE' },
          { value: 'OPERATIVE', text: 'OPERATIVE' },
        ],
      },
      confKey: {
        show: false,
        type: 'MULTI',
        options: [],
        required: true,
      },
      val: { show: false },
      profile: {
        show: false,
        options: [],
        required: true,
      },
      profilePurpose: {
        show: false,
        options: [
          { value: 'ChargePointMaxProfile', text: 'Charge Point Max Profile' },
          { value: 'TxDefaultProfile', text: 'Tx Default Profile' },
          { value: 'TxProfile', text: 'Tx Profile' }
        ],
        required: true,
      },
      stackLevel: {
        show: false,
        required: true,
      },
      vendorId: { show: false },
      messageId: {
        show: false,
        required: true,
      },
      data: {
        show: false,
        required: true,
      },
      hashAlgorithm: {
        show: false,
        required: true,
        options: [
          { value: 'SHA256', text: 'SHA256' },
          { value: 'SHA384', text: 'SHA384' },
          { value: 'SHA512', text: 'SHA512' }
        ],
      },
      issuerNameHash: {
        show: false,
        required: true,
      },
      issuerKeyHash: {
        show: false,
        required: true,
      },
      serialNumber: {
        show: false,
        required: true,
      },
      messageTrigger: {
        show: false,
        options: [
          { value: 'BootNotification', text: 'Boot Notification' },
          { value: 'LogStatusNotification', text: 'Log Status Notification' },
          { value: 'FirmwareStatusNotification', text: 'Firmware Status Notification' },
          { value: 'Heartbeat', text: 'Heartbeat' },
          { value: 'MeterValues', text: 'Meter Values' },
          { value: 'SignChargePointCertificate', text: 'Sign Charge Point Certificate' },
          { value: 'StatusNotification', text: 'Status Notification' }
        ],
      },
      durationInSeconds: { show: false },
      chargingRateUnit: {
        show: false,
        options: [
          { value: 'W', text: 'W' },
          { value: 'A', text: 'A' },
        ],
      },
      customConfKey: {
        show: false,
        required: true,
      },
      location: { show: false },
      retries: {
        show: false,
        required: true,
      },
      retryInterval: {
        show: false,
        required: true,
      },
      start: {
        show: false,
        required: true,
      },
      stop: {
        show: false,
        required: true,
      },
      certificateType: {
        show: false,
        options: [
          { value: 'CentralSystemRootCertificate', text: 'Central System Root Certificate' },
          { value: 'ManufacturerRootCertificate', text: 'Manufacturer Root Certificate' }
        ]
      },
      remoteLocation: { show: false },
      oldestTimestamp: { show: false },
      latestTimestamp: { show: false },
      logType: {
        show: false,
        options: [
          { value: 'DiagnosticsLog', text: 'Diagnostics Log' },
          { value: 'SecurityLog', text: 'Security Log' }
        ]
      },
      requestId: { show: false },
      certificate: { show: false },
      idTag: {
        show: false,
        options: [],
      },
      transactionId: {
        show: false,
        options: []
      },
      expiry: { show: false },
      resetType: {
        show: false,
        options: [
          { value: 'HARD', text: 'HARD' },
          { value: 'SOFT', text: 'SOFT' },
        ],
      },
      updateType: {
        show: false,
        options: [
          { value: 'FULL', text: 'FULL' },
          { value: 'DIFFERENTIAL', text: 'DIFFERENTIAL' },
        ],
      },
      retrieveDateTime: { show: false },
      installDateTime: { show: false },
      signingCertificate: { show: false },
      signature: { show: false },
      triggerMessage: {
        show: false,
        options: [
          { value: 'BootNotification', text: 'Boot Notification' },
          { value: 'DiagnosticsStatusNotification', text: 'Diagnostics Status Notification' },
          { value: 'FirmwareStatusNotification', text: 'Firmware Status Notification' },
          { value: 'Heartbeat', text: 'Heartbeat' },
          { value: 'MeterValues', text: 'Meter Values' },
          { value: 'StatusNotification', text: 'Status Notification' }
        ]
      },
      retrieve: { show: false },
      form: {
        chargePoint: [],
        reservationId: null,
        certificateChain: null,
        connectorId: null,
        availType: null,
        confKeyList: [],
        value: null,
        profilePurpose: null,
        stackLevel: null,
        chargingProfilePk: null,
        vendorId: 'net.i-on.ev',
        messageId: null,
        data: null,
        hashAlgorithm: null,
        issuerNameHash: null,
        issuerKeyHash: null,
        serialNumber: null,
        messageTrigger: null,
        durationInSeconds: null,
        chargingRateUnit: null,
        customConfKey: null,
        location: 'sftp://3.34.208.62/diagnostics',
        retries: null,
        retryInterval: null,
        start: null,
        stop: null,
        certificateType: null,
        remoteLocation: 'sftp://3.34.208.62/diagnostics',
        oldestTimestamp: null,
        latestTimestamp: null,
        logType: null,
        requestId: null,
        certificate: null,
        idTag: null,
        transactionId: null,
        expiry: null,
        resetType: null,
        updateType: null,
        addList: [],
        delList: [],
        retrieveDateTime: null,
        installDateTime: null,
        signingCertificate: null,
        signature: null,
        triggerMessage: null,
        retrieve: null,
      },
      showTimePanel: false,
      request: {},
      requestText: null,
      response: null,
      paginationOptions: {
        currentPage: 1,
        totalCount : 0,
        perPage: 1000,
      }
    };
  },
  mounted() {
    const vm = this;

    vm.getOperationsOptions();
    vm.getChargePointOptions();
    vm.getIdTagOptions();
    vm.getProfileOptions();
  },
  methods: {
    getOperationsOptions() {
      const vm = this;
      vm.operationsOptions = [];

      const codeMap = this.$_app?.code?.operation ?? {};
      vm.operationsOptions = Object.entries(codeMap).map(([key, value]) => ({
        value: key,
        text: value,
      }));
    },
    getChargePointOptions() {
      const vm = this;
      const _url = '/onmapi/view/ChargePoint/list';

      return new Promise((resolve, reject) => {
        http.post(_url, {
          page: vm.paginationOptions.currentPage,
          limit: vm.paginationOptions.perPage,
          searchConditions: [],
          sortCondition: { sortDirection: 'DESC' }
        }).then(res => {
          const _chargePointItems = res.data.items;

          _chargePointItems.forEach(item => {
            vm.chargePoint.options.push({ value: item.chargeBoxId, text: item.chargeBoxId });
          })
        }).catch(err => {
          console.error('Charge Point List Error :: ', err)
        });
      });
    },
    getIdTagOptions() {
      const vm = this;

      // TODO: ID Tag 데이터 가져오기
    },
    getProfileOptions() {
      const vm = this;
      const _url = `/onmapi/ocpp/profile`;

      vm.profile.options = [];
      http.get(_url)
          .then((res) => {
            res.data.forEach(item => {
              vm.profile.options.push({
                value: item.chargingProfilePk,
                text: item.profileName,
                //purpose: item.chargingProfilePurpose,
                //stackLevel: item.stackLevel
              });
            })
          })
          .catch((err) => {
            console.error('Profile List Error :: ', err)
          });
    },
    getReservations(val) {
      const vm = this;

      vm.reservation.options = [];

      // TODO: Reservations 데이터 가져오기
    },
    getConnectorIdOptions(val) {
      const vm = this;
      const _url = `/onmapi/ocpp/charge-point/GetConnectorIds/${vm.operations}/${val}`;

      vm.connectorId.options = [];
      http.get(_url)
          .then((res) => {
            vm.connectorId.options = res.data.map(item => Object.keys(item)[0]);
          })
          .catch((err) => {
            console.error('Connector ID List Error :: ', err)
          });
    },
    getOperations() {
      const vm = this;
      const _url = `/onmapi/ocpp/operations/v1.6/${vm.operations}`;

      http.get(_url)
          .then((res) => {
            vm.confKey.options = Object.entries(res.data.ocppConfKeys).map(([key, value]) => ({
              value: key,
              text: `${key} (${value.match(/\(([^)]+)\)/)[1]})`
            }));
          })
          .catch((err) => {
            console.error('Config Key List Error :: ', err)
          });
    },
    getTransactionIdOptions(val) {
      const vm = this;
      const _url = `/onmapi/ocpp/transaction/GetTransactionId/${val}`;

      vm.transactionId.options = [];
      http.get(_url)
          .then((res) => {
            res.data.forEach(item => {
              vm.transactionId.options.push({
                value: item.transactionId, text: item.transactionId
              });
            })
          })
          .catch((error) => {
            this.$swal('Transaction ID 데이터 조회 실패', '', 'error');
            console.error(error)
          });
    },
    reset() {
      const vm = this;

      vm.chargePoint.show = false;
      vm.chargePoint.type = 'MULTI';

      vm.reservation.show = false;

      vm.certificateChain.show = false;
      vm.certificateChain.required = true;

      vm.connectorId.show = false;
      vm.connectorId.required = true;

      vm.availType.show = false;

      vm.confKey.show = false;
      vm.confKey.type = 'MULTI';
      vm.confKey.required = true;

      vm.val.show = false;

      vm.profile.show = false;
      vm.profile.required = true;

      vm.profilePurpose.show = false;
      vm.profilePurpose.required = true;

      vm.stackLevel.show = false;
      vm.stackLevel.required = true;

      vm.vendorId.show = false;

      vm.messageId.show = false;
      vm.messageId.required = true;

      vm.data.show = false;
      vm.data.required = true;

      vm.hashAlgorithm.show = false;

      vm.issuerNameHash.show = false;

      vm.issuerKeyHash.show = false;

      vm.serialNumber.show = false;

      vm.messageTrigger.show = false;

      vm.durationInSeconds.show = false;

      vm.chargingRateUnit.show = false;

      vm.customConfKey.show = false;
      vm.customConfKey.required = true;

      vm.location.show = false;

      vm.retries.show = false;
      vm.retries.required = true;

      vm.retryInterval.show = false;
      vm.retryInterval.required = true;

      vm.start.show = false;
      vm.start.required = true;

      vm.stop.show = false;
      vm.stop.required = true;

      vm.certificateType.show = false;

      vm.remoteLocation.show = false;

      vm.oldestTimestamp.show = false;
      vm.latestTimestamp.show = false;

      vm.logType.show = false;

      vm.requestId.show = false;

      vm.certificate.show = false;

      vm.idTag.show = false;

      vm.transactionId.show = false;

      vm.expiry.show = false;

      vm.resetType.show = false;

      vm.updateType.show = false;

      vm.retrieveDateTime.show = false;

      vm.installDateTime.show = false;

      vm.signingCertificate.show = false;

      vm.signature.show = false;

      vm.triggerMessage.show = false;

      vm.retrieve.show = false;

      vm.form = {
        chargePoint: [],
        reservationId: null,
        certificateChain: null,
        connectorId: null,
        availType: null,
        confKeyList: [],
        value: null,
        profilePurpose: null,
        stackLevel: null,
        chargingProfilePk: null,
        vendorId: 'net.i-on.ev',
        messageId: null,
        data: null,
        hashAlgorithm: null,
        issuerNameHash: null,
        issuerKeyHash: null,
        serialNumber: null,
        messageTrigger: null,
        durationInSeconds: null,
        chargingRateUnit: null,
        customConfKey: null,
        location: 'sftp://3.34.208.62/diagnostics',
        retries: null,
        retryInterval: null,
        start: null,
        stop: null,
        certificateType: null,
        remoteLocation: 'sftp://3.34.208.62/logs',
        oldestTimestamp: null,
        latestTimestamp: null,
        logType: null,
        requestId: null,
        certificate: null,
        idTag: null,
        transactionId: null,
        expiry: null,
        resetType: null,
        updateType: null,
        addList: [],
        delList: [],
        retrieveDateTime: null,
        installDateTime: null,
        signingCertificate: null,
        signature: null,
        triggerMessage: null,
        retrieve: null,
      }

      vm.request = {};
      vm.requestText = null;
      vm.response = null;
    },
    onChangeOperations() {
      const vm = this;
      vm.reset();

      vm.chargePoint.show = true;

      if (vm.operations === 'SendLocalList') {
        vm.updateType.show = true;

        vm.getIdTagOptions();
      } else if (vm.operations === 'GetConfiguration') {
        vm.confKey.show = true;
        vm.confKey.required = false;
        vm.customConfKey.show = true;
        vm.customConfKey.required = false;

        vm.getOperations();
      } else if (vm.operations === 'ChangeConfiguration') {
        vm.confKey.show = true;
        vm.confKey.type = 'SINGLE';
        vm.val.show = true;

        vm.getOperations();
      } else if (vm.operations === 'SetChargingProfile') {
        vm.profile.show = true;
        vm.connectorId.show = true;
      } else if (vm.operations === 'ClearChargingProfile') {
        vm.profile.show = true;
        vm.profile.required = true;
        vm.profilePurpose.show = true;
        vm.profilePurpose.required = false;
        vm.connectorId.show = true;
        vm.connectorId.required = false;
        vm.stackLevel.show = true;
        vm.stackLevel.required = false;
      } else if (vm.operations === 'RemoteStartTransaction') {
        vm.chargePoint.type = 'SINGLE';
        vm.idTag.show = true;
        vm.connectorId.show = true;
        vm.connectorId.required = false;
        vm.profile.show = true;
      } else if (vm.operations === 'RemoteStopTransaction') {
        vm.chargePoint.type = 'SINGLE';
        vm.transactionId.show = true;
      } else if (vm.operations === 'ReserveNow') {
        vm.chargePoint.type = 'SINGLE';
        vm.connectorId.show = true;
        vm.idTag.show = true;
        vm.expiry.show = true;
      } else if (vm.operations === 'CancelReservation') {
        vm.chargePoint.type = 'SINGLE';
        vm.reservation.show = true;
      } else if (vm.operations === 'ChangeAvailability') {
        vm.connectorId.show = true;
        vm.availType.show = true;
      } else if (vm.operations === 'GetCompositeSchedule') {
        vm.connectorId.show = true;
        vm.durationInSeconds.show = true;
        vm.chargingRateUnit.show = true;
      } else if (vm.operations === 'TriggerMessage') {
        vm.triggerMessage.show = true;
        vm.connectorId.show = true;
        vm.connectorId.required = false;
      } else if (vm.operations === 'DataTransfer') {
        vm.vendorId.show = true;
        vm.messageId.show = true;
        vm.messageId.required = false;
        vm.data.show = true;
        vm.data.required = false;

        vm.request['vendorId'] = vm.form.vendorId;
      } else if (vm.operations === 'GetDiagnostics') {
        vm.location.show = true;
        vm.retries.show = true;
        vm.retries.required = false;
        vm.retryInterval.show = true;
        vm.retryInterval.required = false;
        vm.start.show = true;
        vm.start.required = false;
        vm.stop.show = true;
        vm.stop.required = false;

        vm.request['location'] = vm.form.location;
      } else if (vm.operations === 'Reset') {
        vm.resetType.show = true;
      } else if (vm.operations === 'UpdateFirmware') {
        vm.form.location = 'sftp://3.34.208.62/firmware';
        vm.location.show = true;
        vm.retries.show = true;
        vm.retries.required = false;
        vm.retryInterval.show = true;
        vm.retryInterval.required = false;
        vm.retrieve.show = true;

        vm.request['location'] = vm.form.location;
      } else if (vm.operations === 'UnlockConnector') {
        vm.chargePoint.type = 'SINGLE';
        vm.connectorId.show = true;
      } else if (vm.operations === 'CertificateSigned') {
        vm.certificateChain.show = true;
      } else if (vm.operations === 'DeleteCertificate') {
        vm.hashAlgorithm.show = true;
        vm.issuerNameHash.show = true;
        vm.issuerKeyHash.show = true;
        vm.serialNumber.show = true;
      } else if (vm.operations === 'ExtendedTriggerMessage') {
        vm.messageTrigger.show = true;

        vm.connectorId.show = true;
        vm.connectorId.required = false;
      } else if (vm.operations === 'GetInstalledCertificateIds') {
        vm.certificateType.show = true;
      } else if (vm.operations === 'GetLog') {
        vm.remoteLocation.show = true;
        vm.request['remoteLocation'] = vm.form.remoteLocation;

        vm.oldestTimestamp.show = true;
        vm.latestTimestamp.show = true;

        vm.logType.show = true;

        vm.requestId.show = true;

        vm.retries.show = true;
        vm.retries.required = false;

        vm.retryInterval.show = true;
        vm.retryInterval.required = false;
      } else if (vm.operations === 'InstallCertificate') {
        vm.certificateType.show = true;
        vm.certificate.show = true;
      } else if (vm.operations === 'SignedUpdateFirmware') {
        vm.form.location = 'sftp://3.34.208.62/firmware';
        vm.location.show = true;
        vm.request['location'] = vm.form.location;

        vm.retrieveDateTime.show = true;
        vm.installDateTime.show = true;

        vm.signingCertificate.show = true;
        vm.signature.show = true;

        vm.retries.show = true;
        vm.retries.required = false;

        vm.retryInterval.show = true;
        vm.retryInterval.required = false;

        vm.requestId.show = true;
      }

      if (vm.chargePoint.type === 'MULTI') {
        vm.form.chargePoint = []
      } else {
        vm.form.chargePoint = null
      }
    },
    onDataChange(type) {
      const vm = this;

      if (type === 'chargePoint') {
        let cpArray = [];
        let chargePointText = '';

        if (vm.chargePoint.type === 'MULTI') {
          vm.form.chargePoint.forEach((item, index) => {
            cpArray.push({ 'chargeBoxId': item });
            chargePointText += item;
            chargePointText += vm.form.chargePoint.length === index+1 ? '' : ',';
          });
        } else if (vm.chargePoint.type === 'SINGLE') {
          cpArray.push({ 'chargeBoxId': vm.form.chargePoint })
          chargePointText = vm.form.chargePoint;
        }

        vm.request['chargePointSelectList'] = cpArray;

        if (vm.operations === 'SetChargingProfile' || vm.operations === 'ClearChargingProfile'
            || vm.operations === 'RemoteStartTransaction' || vm.operations === 'ReserveNow'
            || vm.operations === 'ChangeAvailability' || vm.operations === 'GetCompositeSchedule'
            || vm.operations === 'TriggerMessage' || vm.operations === 'UnlockConnector'
            || vm.operations === 'ExtendedTriggerMessage') {
          vm.getConnectorIdOptions(chargePointText);
        } else if (vm.operations === 'RemoteStopTransaction') {
          vm.getTransactionIdOptions(chargePointText);
        } else if (vm.operations === 'CancelReservation') {
          vm.getReservations(chargePointText);
        }
      } else if (type === 'updateType') {
        vm.request['updateType'] = vm.form.updateType;

        if (vm.form.updateType === 'DIFFERENTIAL') {
          vm.request['addUpdateList'] = [];
          vm.request['deleteList'] = [];
        } else {
          delete vm.request.addUpdateList;
          delete vm.request.deleteList;

          vm.getIdTagOptions();
          vm.form.addList = [];
          vm.form.delList = [];
        }
      } else if (type === 'addList') {
        let addArray = [];

        vm.form.addList.forEach(item => {
          addArray.push(item.value);
        })

        vm.request['addUpdateList'] = addArray;
      } else if (type === 'delList') {
        let delArray = [];

        vm.form.delList.forEach(item => {
          delArray.push(item.value)
        })

        vm.request['deleteList'] = delArray;
      } else if (type === 'confKey') {
        if (vm.operations === 'ChangeConfiguration') {
          vm.request['confKey'] = vm.form.confKeyList;
        } else {
          vm.request['confKeyList'] = vm.form.confKeyList;
        }
      } else if (type === 'customConfKey') {
        vm.request['commaSeparatedCustomConfKeys'] = vm.form.customConfKey;
      } else if (type === 'val') {
        vm.request['value'] = vm.form.value;
      } else if (type === 'chargingProfilePk') {
        vm.request['chargingProfilePk'] = vm.form.chargingProfilePk;
      } else if (type === 'connectorId') {
        vm.request['connectorId'] = parseInt(vm.form.connectorId);
      } else if (type === 'profilePurpose') {
        vm.request['chargingProfilePurposeStr'] = vm.form.profilePurpose;
      } else if (type === 'stackLevel') {
        vm.request['stackLevel'] = parseInt(vm.form.stackLevel);
      } else if (type === 'idTag') {
        vm.request['idTag'] = vm.form.idTag;
      } else if (type === 'transactionId') {
        vm.request['transactionId'] = vm.form.transactionId;
      } else if (type === 'expiry') {
        vm.request['expiry'] = vm.form.expiry;
      } else if (type === 'reservationId') {
        vm.request['reservationId'] = vm.form.reservationId;
      } else if (type === 'availType') {
        vm.request['availType'] = vm.form.availType;
      } else if (type === 'durationInSeconds') {
        vm.request['durationInSeconds'] = parseInt(vm.form.durationInSeconds);
      } else if (type === 'chargingRateUnit') {
        vm.request['chargingRateUnit'] = vm.form.chargingRateUnit;
      } else if (type === 'triggerMessage') {
        vm.request['triggerMessage'] = vm.form.triggerMessage;
      } else if (type === 'vendorId') {
        vm.request['vendorId'] = vm.form.vendorId;
      } else if (type === 'messageId') {
        vm.request['messageId'] = vm.form.messageId;
      } else if (type === 'data') {
        vm.request['data'] = vm.form.data;
      } else if (type === 'location') {
        vm.request['location'] = vm.form.location;
      } else if (type === 'retries') {
        vm.request['retries'] = parseInt(vm.form.retries);
      } else if (type === 'retryInterval') {
        vm.request['retryInterval'] = parseInt(vm.form.retryInterval);
      } else if (type === 'start') {
        vm.request['start'] = vm.form.start;
      } else if (type === 'stop') {
        vm.request['stop'] = vm.form.stop;
      } else if (type === 'resetType') {
        vm.request['resetType'] = vm.form.resetType;
      } else if (type === 'retrieve') {
        vm.request['retrieve'] = vm.form.retrieve;
      } else if (type === 'certificateChain') {
        vm.request['certificateChain'] = vm.form.certificateChain;
      } else if (type === 'hashAlgorithm') {
        vm.request['hashAlgorithm'] = vm.form.hashAlgorithm;
      } else if (type === 'issuerNameHash') {
        vm.request['issuerNameHash'] = vm.form.issuerNameHash;
      } else if (type === 'issuerKeyHash') {
        vm.request['issuerKeyHash'] = vm.form.issuerKeyHash;
      } else if (type === 'serialNumber') {
        vm.request['serialNumber'] = vm.form.serialNumber;
      } else if (type === 'messageTrigger') {
        vm.request['messageTrigger'] = vm.form.messageTrigger;
      } else if (type === 'certificateType') {
        vm.request['certificateType'] = vm.form.certificateType;
      } else if (type === 'remoteLocation') {
        vm.request['remoteLocation'] = vm.form.remoteLocation;
      } else if (type === 'oldestTimestamp') {
        vm.request['oldestTimestamp'] = vm.form.oldestTimestamp;
      } else if (type === 'latestTimestamp') {
        vm.request['latestTimestamp'] = vm.form.latestTimestamp;
      } else if (type === 'logType') {
        vm.request['logType'] = vm.form.logType;
      } else if (type === 'requestId') {
        vm.request['requestId'] = vm.form.requestId;
      } else if (type === 'certificate') {
        vm.request['certificate'] = vm.form.certificate;
      } else if (type === 'retrieveDateTime') {
        vm.request['retrieveDateTime'] = vm.form.retrieveDateTime;
      } else if (type === 'installDateTime') {
        vm.request['installDateTime'] = vm.form.installDateTime;
      } else if (type === 'signingCertificate') {
        vm.request['signingCertificate'] = vm.form.signingCertificate;
      } else if (type === 'signature') {
        vm.request['signature'] = vm.form.signature;
      }

      vm.requestText = JSON.stringify(vm.request, null, '\t');
    },
    execute() {
      const vm = this;
      console.log('execute :: ', vm.request);

      http.post(`/onmapi/ocpp/operations/v1.6/${vm.operations}`, vm.request).then((res) => {
        vm.$nextTick(() => {
          vm.getLog();
        })
      })
    },
    getLog() {
      const vm = this;
      const _url = `/onmapi/ocpp/log/search/60`;
    },
    handleOpenChange() {
      const vm = this;
      vm.showTimePanel = false;
    },
    toggleTimePanel() {
      const vm = this;
      vm.showTimePanel = !vm.showTimePanel;
    }
  },
};
</script>

<style lang="scss" scoped>
/* ─── 레이아웃 루트 ────────────────────────────────── */
.csms-ocpp {
  /* Topbar(70px) + Footer(60px) + Padding(10px×2) */
  height: calc(100vh - 155px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

[data-layout="horizontal"] .csms-ocpp {
  height: calc(100vh - 220px);
}

/* ─── 뷰포트 높이 고정 행 ────────────────────────────── */
.viewport-height-fix {
  flex: 1;
  display: flex;
  min-height: 0;
}

/* ─── 좌/우 컬럼 ─────────────────────────────────── */
.col-xl-6 {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* ─── 카드 (높이 꽉 채우기 + body 스크롤) ──────────────── */
.flex-fill-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;

  .card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto; /* 컨텐츠가 길어지면 body 내부 스크롤 */
    min-height: 0;
  }
}

/* ─── 섹션 제목 ──────────────────────────────────── */
.section-title {
  font-size: 18px;
  font-weight: 700;
  flex-shrink: 0;
  padding-bottom: 0.75rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;
}

/* ─── 폼 영역: 라벨 왼쪽 / 인풋 오른쪽 ──────────────────── */
.form-area {
  .form-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 1rem;

    .form-label {
      font-weight: 600;
      padding-top: calc(0.375rem + 1px); /* input과 수직 중앙 맞춤 */
      margin-bottom: 0;
      flex-shrink: 0;
    }
  }
}

/* ─── Charge Point 선택 박스 ─────────────────────── */
.charge-point-box {
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid #cccccc;
  border-radius: 4px;
  padding: 0.75rem;
}

/* ─── 반응형: 1200px 미만 ────────────────────────── */
@media (max-width: 1199.98px) {
  .csms-ocpp {
    height: auto;
    overflow: visible;

    .viewport-height-fix {
      flex-direction: column;
    }

    .col-xl-6 {
      height: auto;
      margin-bottom: 1.5rem;
    }
  }
}

.cp-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 8px;
}

.cp-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;

  input {
    margin-right: 6px;
  }

  &:hover {
    border-color: #5b8def;
    background: #f6f9ff;
  }
}

.cp-item.active {
  border-color: #5b8def;
  background: #eef4ff;
  font-weight: 600;
}

.request-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.request-data-table {
  flex: 1;
  min-height: 0;
  padding: 20px;
  overflow-y: auto;
  border: 1px solid #cccccc;
  border-radius: 4px;
}

.request-data-table pre {
  margin: 0;
  font-size: 12px;
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-word;
}

.confkey-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
</style>
